import { render, staticRenderFns } from "./index.vue?vue&type=template&id=068ae53e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=068ae53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068ae53e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('068ae53e')) {
      api.createRecord('068ae53e', component.options)
    } else {
      api.reload('068ae53e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=068ae53e&scoped=true&", function () {
      api.rerender('068ae53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadAPK/index.vue"
export default component.exports